var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCircleAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05843 6.41659C4.64339 3.67666 7.6058 1.83325 10.9988 1.83325C16.0614 1.83325 20.1654 5.93731 20.1654 10.9999C20.1654 16.0625 16.0614 20.1666 10.9988 20.1666C7.6058 20.1666 4.64339 18.3232 3.05843 15.5833M10.9987 14.6666L14.6654 10.9999M14.6654 10.9999L10.9987 7.33325M14.6654 10.9999H1.83203",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleAction);
export default __webpack_public_path__ + "static/media/Arrow_Circle_Action.11e0e66eb09ee970fc74880473d7f822.svg";
export { ForwardRef as ReactComponent };